import { useContext } from 'react';
import { StaticContext } from '@sm/webassets';

export const BROWSER = Object.freeze({
  IE: 'IE',
  UNKNOWN: 'UNKNOWN',
});

const useBrowser = () => {
  const { userAgent } = useContext(StaticContext);
  /*
    This kind of naive browser testing should be replaced by Thiago's (MOD-312)
    when it is ready. This is just a stop-gap until it becomes available.
    This only detects IE 11; since we do not support earlier versions anyway.
  */
  if (typeof window === 'undefined') {
    if (userAgent.indexOf('Trident/7.0') >= 0) return BROWSER.IE;
    return BROWSER.UNKNOWN;
  }
  if (!!window.MSInputMethodContext && !!document.documentMode) {
    return BROWSER.IE;
  }
  return BROWSER.UNKNOWN;
};

export default useBrowser;
